export const ReceiverKpiCardSkeleton: React.FC = () => (
  <div className='relative w-full max-h-[110px] bg-skeleton border-[3px] border-skeleton-border flex flex-col !px-3 !py-3 !rounded-3xl animate-pulse'>
    <div className='relative min-w-[90px] h-[48px] px-4 py-2 bg-skeleton-hi flex items-center justify-center rounded-full' />
    <div className='flex items-end justify-between px-2 mt-3'>
      <div className='h-[20px] w-[40px] rounded-xl bg-skeleton-hi' />
      <div className='w-[20px] h-[20px] rounded-xl bg-skeleton-hi' />
    </div>
  </div>
)
